import { createFileRoute } from '@tanstack/react-router';

import { requireGuest } from '@/lib/router/route-guards';

export const Route = createFileRoute('/_app/login')({
  beforeLoad: ({ context }) => {
    requireGuest(context);
  },
});
